export default __webpack_public_path__ + "static/media/senior.b9fe5f84.png";